//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import User from '~/components/User.vue';
import GetReport from '~/components/GetReport.vue';
import constant from '~/const';
import Filters from './P2PDealsFilters.vue';
import Extra from './P2PDealsExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    User,
    Extra,
    GetReport,
  },

  props: { userId: { type: String, default: '' } },

  data() {
    return {
      tableConfig,
      loader: false,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapGetters('currencies', ['toCurrencyFormat']),

    ...mapState('p2pDeals', ['page', 'pages', 'data']),
    ...mapGetters('p2pDeals', ['requestData']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('p2pDeals', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
    }),

    getParticipants(steps) {
      const sellers = [];
      const buyers = [];

      steps.forEach((trade) => {
        const seller = trade.cryptoSeller;
        const buyer = trade.cryptoBuyer;

        if (seller && seller.username && seller.username !== '') {
          sellers.push({
            id: trade.cryptoSellerId,
            username: seller.username,
          });
        }

        if (buyer && buyer.username && buyer.username !== '') {
          buyers.push({
            id: trade.cryptoBuyerId,
            username: buyer.username,
          });
        }
      });

      return { sellers, buyers };
    },

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData({
        ...(this.userId && { userId: this.userId }),
      });
    },

    setPage(value) {
      this.setPageAction(value);

      this.loadData({
        ...(this.userId && { userId: this.userId }),
      });
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    getPair(row) {
      const { cryptoSellerCurrency, cryptoBuyerCurrency } = row;
      if (cryptoSellerCurrency && cryptoBuyerCurrency) {
        return `${cryptoSellerCurrency.title} / ${cryptoBuyerCurrency.title}`;
      }
      return '';
    },

    isAuthorOfDeal(row, username) {
      const { advertisement } = row;
      return advertisement.author.username === username;
    },
  },
};
